<template>
<div class="chapter">
<div class="inner_page">
<a id="page_7">
<h2 class="sec_front">NOTABLE BATTLESHIPS AND BATTLECRUISERS</h2>
<table class="table1">
<tbody><tr>
<td class="td1_s w30">IJN <em class="italic">Mikasa</em> (1902)</td>
<td class="td2_s w70">Japanese pre-dreadnought battleship; flagship at the Battle of Tsushima. The world’s oldest existing battleship.</td></tr>
<tr>
<td class="td1_s w30">HMS <em class="italic">Dreadnought (1906)</em></td>
<td class="td2_s w70">British battleship heralding a revolution in battleship design by being the first of its era to have a uniform main battery and steam turbines.</td>
</tr>
<tr>
<td class="td1_s w30">HMS <em class="italic">Invincible</em> (1907)</td>
<td class="td2_s w70">The world’s first battlecruiser; armed as a battleship and fast as a cruiser. Able to chase down most ships, while allowing it to run from more powerful designs.</td>
</tr>
<tr>
<td class="td1_s w30">SMS <em class="italic">Goeben</em> (1911)</td>
<td class="td2_s w70">German battlecruiser transferred to the Ottoman Navy in World War I. In Turkish service until 1954; the world’s longest actively serving capital warship.</td>
</tr>
<tr>
<td class="td1_s w30">IJN <em class="italic">Arkansas</em> (1912)</td>
<td class="td2_s w70">American battleship; the world’s first battleship <em class="italic">directly</em> sunk by an atomic bomb during tests labelled Operation <em class="italic">Crossroads</em> at Bikini Atoll in 1946.</td>
</tr>
<tr>
<td class="td1_s w30">HMS <em class="italic">Queen Elizabeth (1913)</em></td>
<td class="td2_s w70">The world’s first fast battleship combining the advantages of a heavily armoured battleship and a fast battlecruiser in one design.</td>
</tr>
<tr>
<td class="td1_s w30">USS <em class="italic">Arizona</em> (1915)</td>
<td class="td2_s w70">American super-dreadnought sunk by Japanese bombers in the attack on Pearl Harbor on December 7, 1941.</td>
</tr>
<tr>
<td class="td1_s w30">IJN <em class="italic">Ise</em> (1916)</td>
<td class="td2_s w70">Japanese battleship; the first to be converted into a hybrid battleship/aircraft carrier (along with its sister ship <em class="italic">Hyūga</em>).</td>
</tr>
<tr>
<td class="td1_s w30">HMS <em class="italic">Hood</em> (1918)</td>
<td class="td2_s w70">The Royal Navy’s last battlecruiser and the world’s largest warship for two decades. It was sunk by the German battleship <em class="italic">Bismarck</em> in 1941.</td>
</tr>
<tr>
<td class="td1_s w30"><a id="page_8"><em class="italic">Panzerschiff Deutschland</em> (1931)</a></td>
<td class="td2_s w70">Often labelled a “pocket-battleship”, the <em class="italic">Deutschland</em> was the first German capital ship launched after World War I meeting the terms of the Versailles Treaty. Its design motto was to be “more powerful than fast ships, and faster than more powerful ships”.</td></tr>
<tr>
<td class="td1_s w30"><em class="italic">Bismarck</em> (1940)</td>
<td class="td2_s w70">The world’s largest warship when it sank HMS <em class="italic">Hood</em> in 1941. Three days later, <em class="italic">Bismarck</em> finally succumbed to superior British naval forces after the largest hunt for a single warship in history.</td>
</tr>
<tr>
<td class="td1_s w30">USS <em class="italic">Missouri</em> (1944)</td>
<td class="td2_s w70">America’s last completed battleship and the site of Japan’s official surrender ending World War II. Recommissioned for the Korean War and Operation <em class="italic">Desert Storm,</em> the <em class="italic">Mighty Mo</em> was the world’s last active battleship when finally decommissioned in 1992.</td>
</tr>
<tr>
<td class="td1_s w30">IJN <em class="italic">Yamato</em> (1940)</td>
<td class="td2_s w70">The heaviest and most powerfully armed battleship ever completed (along with its sister ship, <em class="italic">Musashi).</em> Sunk by US aircraft in 1945.</td>
</tr>
<tr>
<td class="td1_s w30"><em class="italic">Roma</em> (1940)</td>
<td class="td2_s w70">Italy’s last commissioned battleship; sunk by a German <em class="italic">Fritz X</em> bomb in 1943, one of the world’s first precision guided weapons.</td>
</tr>
<tr>
<td class="td1_s w30"><em class="italic">Jean Bart</em> (1940)</td>
<td class="td2_s w70">Launched in 1940, the French <em class="italic">Jean Bart</em> was the world’s last commissioned battleship in 1949.</td>
</tr></tbody></table></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Notable_battleships.vue?4a0cc944